import { Form, Input } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import React from 'react';
import CustomButton from 'components/custom-button';

const initialValues = {
  name: '',
};

const Filter: React.FC<any> = (props) => {
  const [form] = Form.useForm();
  const { onSubmit } = props;

  const onClearFilter = () => {
    form.resetFields();
    onSubmit({ ...form.getFieldsValue(), name: '' });
  };

  const onFormSubmit = (value: typeof initialValues) => {
    const { ...rest } = value;

    onSubmit({ ...rest });
  };

  return (
    <Form
      form={form}
      name="register"
      layout="inline"
      onFinish={onFormSubmit}
      initialValues={initialValues}
      style={{ rowGap: 12 }}
    >
      <Form.Item name="name">
        <Input placeholder="Tên liveshow" allowClear style={{ width: 240 }} />
      </Form.Item>
      <Form.Item>
        <CustomButton
          bgColor="secondary-green"
          htmlType="submit"
          text="Tìm kiếm"
          icon={<SearchOutlined />}
        />
      </Form.Item>
      <Form.Item>
        <CustomButton
          text="Xóa lọc"
          bgColor="primary-grey"
          icon={<CloseOutlined />}
          onClick={onClearFilter}
        />
      </Form.Item>
    </Form>
  );
};

export default Filter;
